import React from "react";
import { useField } from "formik";
import styles from "./TextArea.module.scss";
import { Badge } from "../../Badge";

/**
 * TextArea component with character count support
 * @param {{
 *   label?: string,
 *   name: string,
 *   placeholder?: string,
 *   maxLength?: number,
 *   onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
 *   disabled?: boolean,
 *   className?: string,
 *   wrapperClassName?: string,
 *   rows?: number
 * }} props
 * @returns {JSX.Element}
 */
function TextArea({
  label,
  name,
  placeholder,
  maxLength,
  onChange,
  disabled,
  className,
  wrapperClassName,
  rows = 10,
  ...props
}) {
  const [field, meta] = useField(name);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      field.onChange(e);
    }
  };

  return (
    <div
      className={`${styles.wrapper} ${wrapperClassName || ""} ${
        meta.touched && meta.error ? styles.error : ""
      }`}
    >
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}

      <div className={styles.inputWrapper}>
        <textarea
          {...field}
          {...props}
          id={name}
          className={`${styles.textArea} ${className || ""}`}
          placeholder={placeholder}
          onChange={handleChange}
          disabled={disabled}
          maxLength={maxLength}
          rows={rows}
        />

        {maxLength && (
          <div className={styles.charCount}>
            <Badge text="Character Count" />
            <span>
              {field.value?.length || 0}/{maxLength}
            </span>
          </div>
        )}
      </div>
      {meta.touched && meta.error ? (
        <div className={styles.errorMessage}>
          <small>{meta.error}</small>
        </div>
      ) : null}
    </div>
  );
}

export default TextArea;
